// extracted by mini-css-extract-plugin
export default {"wrapper":"FormWrapper_wrapper__B80ST","button":"FormWrapper_button__7RseF"};